import CustomTooltip from '@/DesignSystem/components/tooltip/CustomTooltip';
import { Typography } from '@mui/material';

const Apercibidos = ({ cards, size = 12, color = '#d8c749', ...props }) => {
    const nextCard = cards + 1;

    if (nextCard % 5 !== 0) {
        return null;
    }

    return (
        <CustomTooltip title="Jugador apercibido, si ve otra se perdería la siguiente jornada" arrow>
            <Typography
                component={'span'}
                sx={{
                    background: color,
                    color: '#000',
                    fontSize: 10,
                    fontWeight: 500,
                    width: size,
                    height: size,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '4px',
                }}
                {...props}
            >
                {cards}
            </Typography>
        </CustomTooltip>
    );
};

export default Apercibidos;
